import { render } from "./SearchTermsList.vue?vue&type=template&id=e7a5e6ec"
import script from "./SearchTermsList.vue?vue&type=script&lang=js"
export * from "./SearchTermsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__